import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

type InformationPopupProps = {
  open: boolean;
  onClose: () => void;
};

const InformationPopup = ({ open, onClose }: InformationPopupProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { padding: '0px 10px 25px 10px' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px',
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {t('mutations.informationDialogSaveConcept.Title')}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t('mutations.informationDialogSaveConcept.Text')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default InformationPopup;
